export default "__VITE_ASSET__6d13c653__"